import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  getMediaDeliveryConfig,
  loadImageKitConfig,
  subscribeMediaDeliveryConfig
} from '../utils/imageKitConfig';

const defaultValue = {
  endpoint: '',
  deliveryReady: false,
  deliveryMode: 'proxy',
  mediaDeliveryBase: '',
  mediaVideoDeliveryBase: ''
};

const ImageKitConfigContext = createContext(defaultValue);

export function ImageKitConfigProvider({ children }) {
  const [config, setConfig] = useState(() => getMediaDeliveryConfig());

  useEffect(() => subscribeMediaDeliveryConfig(setConfig), []);

  useEffect(() => {
    loadImageKitConfig();
  }, []);

  return (
    <ImageKitConfigContext.Provider value={config}>
      {children}
    </ImageKitConfigContext.Provider>
  );
}

export function useImageKitDelivery() {
  return useContext(ImageKitConfigContext);
}

/** @deprecated use useImageKitDelivery().endpoint */
export function useImageKitEndpoint() {
  return useContext(ImageKitConfigContext).endpoint;
}
